export default __webpack_public_path__ + "static/media/select-close.16a8b65d.svg";